import FolderRecords from "./FolderRecords";

export default FolderRecords;